import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { PanelCiudadano } from '../../../../../../_entities/panelCiudadano/panelCiudadano';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { DatePipe } from '@angular/common';
import { PanelAdministracionService } from '../../../../../panel-vigilancia/services/panel-administracion.service';
import { DxValidationGroupComponent } from 'devextreme-angular';
import Swal from 'sweetalert2';

@Component({
  selector: 'kt-historico-panel',
  templateUrl: './historico-panel.component.html',
  styleUrls: ['./historico-panel.component.scss']
})
export class HistoricoPanelComponent implements OnInit {
  @ViewChild('targetGroup', { static: false }) validationGroup: DxValidationGroupComponent;
	public reportePos: PanelCiudadano[];

	public fechaInicial;
	public fechaFinal;
	public fechaFin;
	public fechaInicio;
	public datosReporte = [];
	public isDisabled: boolean = true;
	public showTable: boolean = false;
  public loadingMessage: string = 'Cargando...';
  public loadingVisible: boolean = false;

	public currentFilter: any;

	public showFilterRow: boolean;
  constructor(private panelService:PanelAdministracionService,private toastService: ToastrService,
		private dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) public data,
		public dialogRef: MatDialogRef<HistoricoPanelComponent>,
		private datepipe: DatePipe) { 
    this.showFilterRow = true;
  }

  ngOnInit(): void {
    console.log(this.data)
  }

  obtenerHistorico(fechaInicio,fechaFinal){
    if (this.validationGroup.instance.validate().isValid) {
      this.loadingVisible = true;
      this.fechaInicial = this.datepipe.transform(fechaInicio, "yyyy-MM-dd HH:mm:ss");
      this.fechaFinal = this.datepipe.transform(fechaFinal, "yyyy-MM-dd HH:mm:ss");
      setTimeout(() => {
        this.loadingMessage = 'Esto puede tardar unos segundos...';
      }, 10000);
      this.panelService.obtenerPanelesHistorico(this.data.id, this.fechaInicial,this.fechaFinal).subscribe((result: PanelCiudadano[])=>{
        this.reportePos = result;
        console.log(this.reportePos)
        result.map(p => {
          if(p.boton == null || p.boton == ""){
            p.boton = 'Sin registro'
          } else{
            p.boton = p.boton
          }
        })
        result.map(q => {
          if(q.codigoProtocolo == null){
            q.codigoProtocolo = 'Sin registro'
          } else {
            q.codigoProtocolo = q.codigoProtocolo
          }
        })

        if (this.reportePos.length > 0) {
          this.crearReporte(result);
        }
        else {
          this.isDisabled = true;
          this.showTable = false;
          this.loadingVisible = false;
					this.toastService.info("No existen datos en ese rango de fechas")
        }
        if(this.datosReporte.length > 0) {
          this.isDisabled = false;
        }
        if (this.reportePos.length > 0) {
          this.loadingVisible = false;
          this.showTable = true;
        }
      },err=>{
        console.log(err);
      })
    }
  }

  crearReporte(reporte: PanelCiudadano[]) {
		this.datosReporte = [];
		reporte.forEach(q => {
			this.datosReporte.push({
				'Evento': this.obtenerEstatus(q.descripcionAlarma),
        'Nombre': q.nombre,
        'Nombre del Botón': q.boton,
        'Número de Serie': q.numeroSerie,
        'Modelo': q.modelo,
        'Descripción': q.descripcion,
        'DevIndex': q.devIndex,
        'Lat': q.lat,
        'Lng': q.lng,
        'Imagen': q.imagen,
        // 'Nombre Contacto': q.nombreContacto,
        // 'Teléfono Contacto': q.telefonoContacto,
        // 'Código de Protolo': q.codigoProtocolo
			});
			if (this.datosReporte.length > 0) {
				this.isDisabled = false;
			}
		});
	}

  obtenerEstatus(descripcionAlarma) {
		let evento = '';
		switch (descripcionAlarma) {
			case 'Lid Restored':
				evento = 'Tapa Restaurada';
				break;
			case 'Lid Opened':
				evento = 'Tapa Abierta';
				break;
      case 'Audible Panic Alarm':
        evento = 'Alarma de Pánico';
        break;
      case 'Alarm Silenced':
        evento = 'Alarma Silenciada';
        break;
      case 'Device Restored':
        evento = 'Dispositivo Restaurado';
        break;
      case 'IP Address Already Used':
        evento = 'Dirección IP Utilizada';
        break;
      case 'Normal IP address':
        evento = 'DIrección IP Normal';
        break;
      case 'Armed':
        evento = 'Armado';
        break;
      case 'Disarmed':
        evento = 'Desarmado';
        break;

      case 'Expander AC Power Loss':
				evento = 'Perdida de Alimentación';
				break;
      case '24H Alarm':
        evento = 'Alarma Sensor de Movimiento'
        break;
      case 'Network Fault':
        evento = 'Fallo de Red';
        break;
      case 'Device Offline':
        evento = 'Dispositivo Sin Conexión';
        break;

      case 'Cellular Fault':
        evento = 'Fallo de Celular';
        break;
      case 'Cellular Restored':
        evento = 'Celular Restaurado';
        break;
      case 'Mains Power Lost':
        evento = 'Perdida de Alimentación de Red'
        break;
      case 'Jamming Detected':
        evento = 'Interferencia Detectada';
        break;
      case 'Jamming Restored':
        evento = 'Interferencia Restaurada';
        break;
      case 'Device Enrolled':
        evento = 'Dispositivo Inscrito';
        break;
      case 'Device Deleted':
        evento = 'Dispositivo Eliminado'
        break;
        
      case 'Mains Power Restored':
        evento = 'Red Eléctrica Restaurada';
        break;
      case 'Network Restored':
        evento = 'Red Restaurada';
        break;

      case null:
        evento = 'Sin Datos';
        break;
		}
		return evento;
	}

  public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}
}
